import PropTypes from 'prop-types';

// third-party
import SyntaxHighlighter from 'react-syntax-highlighter';
// Use CommonJS build for Jest compatibility
import { a11yDark } from 'react-syntax-highlighter/dist/cjs/styles/hljs';

// ==============================|| CODE HIGHLIGHTER ||============================== //

export default function SyntaxHighlight({ children, ...others }) {
    return (
        <SyntaxHighlighter
            language="javascript"
            showLineNumbers
            style={a11yDark}
            {...others}
        >
            {children}
        </SyntaxHighlighter>
    );
}

SyntaxHighlight.propTypes = {
    children: PropTypes.node,
};
